// extracted by mini-css-extract-plugin
export var alternatingLayoutItem = "section_alternating_layout-module--alternatingLayoutItem--gwV-O";
export var artwork = "section_alternating_layout-module--artwork--6YQtr";
export var artworkWrapper = "section_alternating_layout-module--artworkWrapper--l9c79";
export var copyWrapper = "section_alternating_layout-module--copyWrapper--tIvxy";
export var isReversed = "section_alternating_layout-module--isReversed--IAeiP";
export var ratio_4_8 = "section_alternating_layout-module--ratio_4_8--y4f7S";
export var ratio_5_7 = "section_alternating_layout-module--ratio_5_7--SdYoK";
export var ratio_6_6 = "section_alternating_layout-module--ratio_6_6--tacCW";